import React from 'react';
import './style.scss';
import { Spinner } from 'react-bootstrap';
import { ArrowLeft } from '../../../../components/atoms/icons';
import getAllUserByTypeRes from '../../../../components/api/user/getAllByType.json';

interface Props {
    onNavigateBack: () => void;
    userById: typeof getAllUserByTypeRes.data[0] | undefined;
    currentScreen: string | undefined
}

function RenderHeader(props : Props) {
  const { onNavigateBack, userById, currentScreen } = props;
  return (
    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '35px' }}>
      <div className="d-flex align-items-center">
        <button
          onClick={onNavigateBack}
          type="button"
          className="border-0 bg-transparent"
          style={{ marginTop: '4px' }}
        >
          <ArrowLeft />
        </button>
        <div className="px-3">
          <div className="user-profile">
            <div className="user-name">
              {userById ? (userById.firstname?.slice(0, 1) ?? '-') : <Spinner animation="border" size="sm" />}
            </div>
          </div>
        </div>
        <div className="ms-0">
          {userById ? (
            <h4 className="fw-bold fz-16 mb-0 mt-2">
              {userById.firstname && userById.lastname ? `${userById.firstname} ${userById.lastname}` : '-'}
            </h4>
          ) : <Spinner animation="border" size="sm" />}
          <div className="fz-14 text-secondary mt-0">
            {userById ? (userById.username ?? '-') : <Spinner animation="border" size="sm" />}
          </div>
        </div>
      </div>
      <div className="fz-14 text-black-50" style={{ marginTop: '4px' }}>
        {currentScreen === 'active' ? 'Added on: -' : 'Deleted on: -'}
      </div>
    </div>
  );
}

export default RenderHeader;
